import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'

import { LoadingBox, MessageBox } from '../components'
import Main from './Main/Main'
import Login from './Login/Login'
import Signup from './Signup/Signup'
import ForgotPassword from './ForgotPassword/ForgotPassword'
import NewPassword from './ForgotPassword/NewPassword'

class App extends Component {
  render() {
    const {
      system: {
        messageBox: { msgOK, msgNOK },
        loadingBox: { message, title },
        showLoadingBox,
      },
    } = this.props
    return (
      <React.Fragment>
        <Router>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/signup" component={Signup} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/new-password" component={NewPassword} />
            <Route path="/main" component={Main} />
          </Switch>
        </Router>
        <MessageBox msgOk={msgOK} msgNOk={msgNOK} />
        <LoadingBox message={message} title={title} showLoadingBox={showLoadingBox} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ system }) => ({ system })
export default connect(mapStateToProps)(App)

// Reference:
// https://react-icons.netlify.com/#/
